var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hot-topic"},[_c('div',{staticClass:"hot-topic-title"},[_vm._v("推荐专题")]),_vm._l((_vm.hotTopics),function(item,index){return _c('topic-card',{key:index,attrs:{"hotTopic":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }